import { Colors, Router } from '@lightningjs/sdk';
import lng from '@lightningjs/core';

export default class ProfileAvatar extends lng.Component {
  static _template() {
    return {
      Item: {
        Image: { collision: true },
        Name: {
          w: 254,
          y: 280,
          text: {
            fontFace: 'OpenSans-SemiBold',
            text: '',
            textAlign: 'center',
            textOverflow: 'ellipsis',
            fontSize: 36,
            wordWrapWidth: this.w,
            maxLines: 2,
            wordWrap: false,
          },
        },
      },
      FocusRing: {},
    };
  }

  _construct() {
    super._construct();
    this.spacing = 0;
  }

  set src(val) {
    this._src = val;
  }

  set index(val) {
    this._index = val;
  }

  get src() {
    return this._src;
  }

  set data({ id, autoplay }) {
    this._data = { id, autoplay };
  }

  get data() {
    return this._data;
  }

  get _Image() {
    return this.tag('Item.Image');
  }

  get _Name() {
    return this.tag('Item.Name');
  }

  get _FocusRing() {
    return this.tag('FocusRing');
  }

  _focus() {
    this._FocusRing.smooth = { color: Colors('#02AC25').get() };
    this._Name.smooth = { color: Colors('#02AC25').get() };
  }

  _handleHover() {
    this.fireAncestors('$setState', 'Profiles');
    this.fireAncestors('$setIndex', this._index);
    this._focus();
  }

  _unfocus() {
    this._FocusRing.smooth = { color: Colors('#d6d6d7').get() };
    this._Name.smooth = { color: Colors('#d6d6d7').get() };
  }

  _handleUnhover() {
    this._unfocus();
  }

  _captureEnter() {
    Router.navigate(
      `#profile/edit-profile/${this._data.id}`,
      {
        autoplay: this._data.autoplay,
      },
      true
    );
  }

  _handleClick() {
    this._captureEnter();
  }

  _firstEnable() {
    this._FocusRing.patch({
      w: this.w + this.spacing,
      h: this.h + this.spacing,
      mount: 0.5,
      x: this.w / 2,
      y: this.h / 2,
      zIndex: 2,

      texture: lng.Tools.getRoundRect(
        this.w + this.spacing,
        this.h + this.spacing,
        this.w / 2,
        5,
        Colors('#d6d6d7').get(),
        false
      ),
    });

    this._Image.patch({
      rtt: true,
      zIndex: 2,
      w: this.w,
      h: this.h,
      texture: {
        type: lng.textures.ImageTexture,
        src: this._src,
        resizeMode: { type: 'cover', w: this.w, h: this.h },
      },
      shader: {
        type: lng.shaders.RoundedRectangle,
        radius: this.w / 2,
      },
    });

    this._Name.patch({
      text: { text: this.title },
    });
  }
}
